/* Halloween-Landingpage 2026: Countdown, Rabattcode, Slider, Filter und Kaufbox.
   Jede Section initialisiert sich über data-wb-hw selbst, auch nach einem
   Reload im Theme-Editor. */
(function () {
  if (window.WbHw) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var log = window.wbHwLog = window.wbHwLog || [];

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- Countdown ---------- */
  function globalEnd() {
    var bar = document.querySelector('.wb-hw-cbar[data-end]');
    return bar ? bar.getAttribute('data-end') : '';
  }

  function initCountdown(el) {
    var end = Date.parse(el.getAttribute('data-end') || globalEnd());
    if (isNaN(end)) return;
    var units = {};
    el.querySelectorAll('[data-unit]').forEach(function (u) { units[u.getAttribute('data-unit')] = u; });
    function tick() {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (units.d) units.d.textContent = pad(Math.floor(left / 86400));
      if (units.h) units.h.textContent = pad(Math.floor(left % 86400 / 3600));
      if (units.m) units.m.textContent = pad(Math.floor(left % 3600 / 60));
      if (units.s) units.s.textContent = pad(left % 60);
      if (left === 0) clearInterval(timer);
    }
    var timer = setInterval(tick, 1000);
    tick();
  }

  /* Die Leiste steht im Template unter dem Header, Figma zeigt sie darüber. */
  function initTopbar(el) {
    if (designMode || el.getAttribute('data-above-header') !== 'true') return;
    var section = el.closest('.shopify-section');
    var header = document.getElementById('shopify-section-header-wellbe') ||
      document.getElementById('shopify-section-navbar') ||
      (document.querySelector('.wellbe-header') && document.querySelector('.wellbe-header').closest('.shopify-section'));
    if (section && header && header.parentNode) header.parentNode.insertBefore(section, header);
  }

  /* ---------- Rabattcode beim Seitenaufruf vormerken ---------- */
  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function rememberCode(code) {
    if (!code || readCookie('discount_code').toUpperCase() === code.toUpperCase()) {
      log.push('code bereits gesetzt');
      return;
    }
    var url = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart.js') + '&_=' + Date.now();
    fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function () {
        if (readCookie('discount_code').toUpperCase() === code.toUpperCase()) { log.push('gesetzt via fetch'); return; }
        throw new Error('cookie fehlt');
      })
      .catch(function () {
        /* Netz: anderer Code-Pfad im Browser, folgt der Weiterleitung und setzt das Cookie. */
        var img = new Image();
        img.onerror = img.onload = function () { log.push('gesetzt via Bild: ' + (readCookie('discount_code') || 'leer')); };
        img.src = url + '1';
      });
  }

  function initAutocode(el) {
    if (designMode || el.getAttribute('data-autocode') !== 'true') return;
    rememberCode(el.getAttribute('data-code'));
  }

  /* ---------- Code kopieren ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wb-hw-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-wb-hw-copy');
    function done() {
      btn.classList.add('is-copied');
      setTimeout(function () { btn.classList.remove('is-copied'); }, 1600);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, fallback);
    } else {
      fallback();
    }
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(ta);
      done();
    }
  });

  /* ---------- Scroll-Slider (Kreise, Bewertungen, Videos) ---------- */
  function scrollSlider(el, track, opts) {
    var slides = Array.prototype.slice.call(track.children);
    var dotsWrap = el.querySelector('[data-wb-hw-dots]');
    var counter = el.querySelector('[data-wb-hw-counter]');
    var prev = el.querySelector('[data-wb-hw-prev]');
    var next = el.querySelector('[data-wb-hw-next]');
    var nav = el.querySelector('.wb-hw-slider__nav');

    function step() {
      if (slides.length < 2) return track.clientWidth;
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }
    function perView() { return Math.max(1, Math.round(track.clientWidth / step())); }
    function pages() { return Math.max(1, Math.ceil(slides.length / perView())); }
    function current() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 2) return 0;
      if (track.scrollLeft >= max - 2) return pages() - 1;
      return Math.round(track.scrollLeft / (step() * perView()));
    }
    function go(page) {
      var n = pages();
      var p = ((page % n) + n) % n;
      track.scrollTo({ left: p * perView() * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function renderDots() {
      var n = pages();
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Seite ' + (i + 1));
          b.addEventListener('click', go.bind(null, i));
          dotsWrap.appendChild(b);
        }
        dotsWrap.hidden = n < 2;
      }
      if (nav) nav.hidden = n < 2;
      /* Passt alles ohne Wischen hinein, darf die Reihe mittig stehen. */
      track.classList.toggle('is-fit', track.scrollWidth - track.clientWidth <= 2);
    }
    function update() {
      var c = current();
      if (dotsWrap) dotsWrap.querySelectorAll('button').forEach(function (d, i) { d.classList.toggle('is-active', i === c); });
      if (counter) counter.textContent = (c + 1) + '/' + pages();
    }
    if (prev) prev.addEventListener('click', function () { go(current() - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(current() + 1); restart(); });
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', function () { renderDots(); update(); });
    renderDots();
    update();

    /* Autoplay: ein Element weiter, am Ende zurück an den Anfang. */
    var timer = null;
    var paused = false;
    function advance() {
      if (paused) return;
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 2) return;
      var target = track.scrollLeft + step();
      track.scrollTo({ left: target > max + 2 ? 0 : Math.min(target, max), behavior: 'smooth' });
    }
    function restart() {
      if (!opts || !opts.autoplay || reduceMotion) return;
      clearInterval(timer);
      timer = setInterval(advance, opts.interval || 3000);
    }
    if (opts && opts.autoplay) {
      ['mouseenter', 'touchstart', 'focusin'].forEach(function (ev) { el.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ['mouseleave', 'touchend', 'focusout'].forEach(function (ev) { el.addEventListener(ev, function () { paused = false; }, { passive: true }); });
      restart();
    }
  }

  function initCarousel(el) {
    var track = el.querySelector('[data-wb-hw-track]');
    if (!track) return;
    scrollSlider(el, track, {
      autoplay: el.getAttribute('data-autoplay') === 'true',
      interval: parseInt(el.getAttribute('data-interval'), 10) || 3000
    });
  }

  function initSlider(el) {
    var track = el.querySelector('.wb-hw-slider__track');
    if (track) scrollSlider(el, track, null);
  }

  /* ---------- Videos ---------- */
  function initVideos(el) {
    el.querySelectorAll('.wb-hw-video').forEach(function (card) {
      var video = card.querySelector('video');
      var btn = card.querySelector('.wb-hw-video__play');
      if (!video || !btn) return;
      video.removeAttribute('controls');
      btn.addEventListener('click', function () {
        el.querySelectorAll('video').forEach(function (other) { if (other !== video) other.pause(); });
        video.controls = true;
        video.play();
        card.classList.add('is-playing');
      });
      video.addEventListener('ended', function () { card.classList.remove('is-playing'); video.controls = false; });
    });
  }

  /* ---------- Geschmacksauswahl ---------- */
  function initFlavors(el) {
    var buttons = el.querySelectorAll('.wb-hw-formula__flavor');
    var slides = el.querySelectorAll('.wb-hw-formula__slide');
    var links = el.querySelectorAll('[data-wb-hw-flavor-link]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = btn.getAttribute('data-flavor');
        buttons.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-flavor') === i); });
        var handle = btn.getAttribute('data-handle');
        if (handle) links.forEach(function (a) { a.setAttribute('data-wb-hw-goto', handle); });
      });
    });
  }

  /* ---------- Produktfilter ---------- */
  function initProducts(el) {
    var limit = parseInt(el.getAttribute('data-limit'), 10) || 8;
    var cards = el.querySelectorAll('.wb-hw-card');
    var tabs = el.querySelectorAll('.wb-hw-tab');
    var expand = el.querySelector('[data-wb-hw-expand]');
    var expanded = false;
    var current = '';
    function apply(cat) {
      current = cat;
      var shown = 0;
      var hiddenMatches = 0;
      cards.forEach(function (card) {
        var cats = (card.getAttribute('data-cats') || '').split(',');
        var match = !cat || cats.indexOf(cat) !== -1;
        var show = match && (expanded || shown < limit);
        if (show) shown++;
        else if (match) hiddenMatches++;
        card.hidden = !show;
      });
      /* „Alle Produkte ansehen“ klappt die Liste auf der Seite auf. */
      if (expand) expand.closest('.wb-hw-products__more').hidden = expanded || hiddenMatches === 0;
    }
    if (expand) expand.addEventListener('click', function () { expanded = true; apply(current); });
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        apply(tab.getAttribute('data-cat'));
      });
    });
    apply('');
  }

  /* ---------- Kaufbox ---------- */
  /* Der Slidecart ist das Objekt `const CartDrawer` aus
     sections/cart-drawer-new-with-more-products.liquid. Als const hängt es
     nicht an window, deshalb über den nackten Namen ansprechen. */
  function themeDrawer() {
    try {
      /* global CartDrawer */
      if (typeof CartDrawer !== 'undefined' && CartDrawer && typeof CartDrawer.refreshCart === 'function') return CartDrawer;
    } catch (e) {}
    return null;
  }

  function openCart() {
    var drawer = themeDrawer();
    if (drawer) {
      drawer.openCart();
      return drawer.refreshCart();
    }
    window.location.href = root + 'cart';
  }

  function addToCart(variantId, code) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add');
        if (!code) return null;
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code })
        });
      })
      .then(openCart);
  }

  function initOffer(el) {
    var panels = el.querySelectorAll('.wb-hw-offer__panel');
    var images = el.querySelectorAll('.wb-hw-offer__image');
    var dots = el.querySelectorAll('.wb-hw-offer__dot');
    var button = el.querySelector('[data-wb-hw-buy]');
    var error = el.querySelector('.wb-hw-offer__error[role="alert"]');
    var code = el.getAttribute('data-code') || '';
    var count = panels.length;
    var index = 0;

    /* Karussell: jede Slide bekommt ihre Position relativ zum aktiven Produkt.
       Ringförmig gerechnet, damit es vom letzten zum ersten Produkt ohne
       Rücklauf weitergeht. */
    var POS = ['is-center', 'is-next', 'is-prev', 'is-far-left'];
    function place() {
      images.forEach(function (img, n) {
        var o = (n - index + count) % count;
        if (o > count / 2) o -= count;
        POS.forEach(function (c) { img.classList.remove(c); });
        if (o === 0) img.classList.add('is-center');
        else if (o === 1) img.classList.add('is-next');
        else if (o === -1) img.classList.add('is-prev');
        else if (o < 0) img.classList.add('is-far-left');
        img.setAttribute('aria-hidden', o === 0 ? 'false' : 'true');
      });
    }

    function show(i) {
      index = ((i % count) + count) % count;
      panels.forEach(function (p, n) { p.classList.toggle('is-active', n === index); });
      place();
      dots.forEach(function (p, n) { p.classList.toggle('is-active', n === index); });
      if (error) error.classList.remove('is-visible');
    }

    var prev = el.querySelector('[data-wb-hw-prev]');
    var next = el.querySelector('[data-wb-hw-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-slide'), 10)); }); });

    /* Wischen auf dem Bild */
    var stage = el.querySelector('.wb-hw-offer__images');
    var startX = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
        startX = null;
      }, { passive: true });
    }

    panels.forEach(function (panel) {
      var packs = panel.querySelectorAll('.wb-hw-pack');
      function select(pack) { packs.forEach(function (p) { p.classList.toggle('is-selected', p === pack); }); }
      packs.forEach(function (pack) {
        var input = pack.querySelector('input');
        if (input) input.addEventListener('change', function () { select(pack); });
      });
      var checked = panel.querySelector('.wb-hw-pack__input:checked');
      if (checked) select(checked.closest('.wb-hw-pack'));
      else if (packs.length) {
        packs[0].querySelector('input').checked = true;
        select(packs[0]);
      }
    });

    show(0);

    /* Von Kreisen, Karten und Formel-Button: Produkt auswählen, ohne Seitenwechsel. */
    el.__wbHwSelect = function (handle) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-handle') === handle) { show(i); return true; }
      }
      return false;
    };

    if (!button) return;
    button.addEventListener('click', function () {
      var input = panels[index] && panels[index].querySelector('.wb-hw-pack__input:checked');
      var variantId = input ? parseInt(input.value, 10) : 0;
      if (!variantId) {
        if (error) error.classList.add('is-visible');
        return;
      }
      button.disabled = true;
      addToCart(variantId, code)
        .catch(function () { if (error) error.classList.add('is-visible'); })
        .finally(function () { button.disabled = false; });
    });
  }

  /* ---------- Sprungziele: alles bleibt auf der Seite ---------- */
  function stickyOffset() {
    var h = 0;
    document.querySelectorAll('#shopify-section-header-wellbe, .wellbe-header, #shopify-section-navbar, .wb-hw-cbar').forEach(function (n) {
      var pos = getComputedStyle(n).position;
      if (pos === 'fixed' || pos === 'sticky') {
        var r = n.getBoundingClientRect();
        if (r.top <= 1 && r.bottom > h) h = r.bottom;
      }
    });
    return h;
  }

  function scrollToEl(target) {
    if (!target) return;
    var y = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset() - 8;
    window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.wb-hw [data-wb-hw-goto], .wb-hw a[href^="#"]');
    if (!a) return;
    var handle = a.getAttribute('data-wb-hw-goto');
    var offer = document.querySelector('[data-wb-hw~="offer"]');
    if (handle !== null) {
      e.preventDefault();
      if (handle && offer && offer.__wbHwSelect && offer.__wbHwSelect(handle)) {
        scrollToEl(offer);
        return;
      }
      /* Kein Kaufbox-Slide: Kreise springen zur Bundle-Liste, Karten legen direkt in den Warenkorb. */
      var fallback = a.getAttribute('data-fallback');
      var fallbackEl = fallback && document.querySelector(fallback);
      if (fallbackEl) {
        scrollToEl(fallbackEl);
        return;
      }
      var variant = parseInt(a.getAttribute('data-variant'), 10);
      if (variant) {
        var code = a.getAttribute('data-code') || (offer && offer.getAttribute('data-code')) || '';
        a.classList.add('is-loading');
        addToCart(variant, code)
          .catch(function () { window.location.href = root + 'cart'; })
          .finally(function () { a.classList.remove('is-loading'); });
        return;
      }
      scrollToEl(offer);
      return;
    }
    var id = (a.getAttribute('href') || '').slice(1);
    var target = id && document.getElementById(id);
    if (target) {
      e.preventDefault();
      scrollToEl(target);
    }
  });

  var inits = {
    countdown: initCountdown,
    topbar: initTopbar,
    autocode: initAutocode,
    carousel: initCarousel,
    slider: initSlider,
    videos: initVideos,
    flavors: initFlavors,
    products: initProducts,
    offer: initOffer
  };

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-wb-hw]').forEach(function (el) {
      if (el.__wbHw) return;
      el.__wbHw = true;
      el.getAttribute('data-wb-hw').split(' ').forEach(function (name) {
        if (inits[name]) inits[name](el);
      });
    });
  }

  window.WbHw = { init: initAll };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
